module.exports = __webpack_public_path__ + "img/chinonso.51f64ea6.png";